import globals from '../../../../scripts/modules/globals';
import parameters from '../../../../scripts/modules/parameters';
import _ from 'lodash';
import axios from 'axios';
import map from '../map';
import utility from '../utility';
import filter from '../filter';
import modal from '../modal';
import template from './template';

const populate = (data, content, reset = false) => {
	if ( reset ) content.innerHTML = '';
	if ( data ) data.forEach((obj) => content.innerHTML += template.listing(obj));
	if ( !data ) content.innerHTML = template.notFound();
	modal('#property-listing > li');
}

// Flag the current state of the listing.
const flag = ( total, status, current, content ) => {
	current = ( !current || current > total ) ? 1 : current;
	content.setAttribute('data-current', current);
	content.setAttribute('data-total', total);
	content.setAttribute('data-status', status);
}

// Load the initial state of the listings.
const load = ( reset = false ) => {
	const content = document.getElementById('property-listing');
	axios.get( utility.query.listing() )
		.then( (response) => {
			let data = response.data.properties;
			let total = response.data.results['total-pages'];
			let status = (total <= 1) ? 'done' : 'in-progress';
			flag( total, status, parameters.getKey('page'), content );
			populate( data, content, reset );
			map.populate(data);
		}).catch( (error) => console.log(error) );
}

export default {
	flag,
	load
}
